var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CChartDoughnut',{staticStyle:{"height":"250px"},attrs:{"datasets":_vm.datasets,"labels":_vm.labels,"options":{
    responsive: true,
    maintainAspectRatio: false,
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }